// extracted by mini-css-extract-plugin
module.exports = {"hair-toggle":"hair-toggle_hair-toggle__60aXh","hair-toggle-compact":"hair-toggle_hair-toggle-compact__E0_Cn"};